const FORM_ELEMENT_COMPUTED_MIXIN = {
  emits: ['update:modelValue'],
  computed: {
    currentValue: {
      get () {
        return typeof this.modelValue !== 'undefined' ? this.modelValue : null
      },
      set (newValue) {
        this.$emit('update:modelValue', newValue)
      }
    },
    label () {
      return this.formField.label_text
    },
    elementId () {
      return this.formField.element_id
    },
    elementDisabled () {
      return !this.offerEnabled
    },
    currentValueDefined () {
      return typeof this.currentValue !== 'undefined'
    }
  }
}

export default FORM_ELEMENT_COMPUTED_MIXIN
